webpackJsonp(["blob"],{

/***/ "./blob/blob_file_dropzone.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_url_utility__ = __webpack_require__("./lib/utils/url_utility.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_url_utility___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lib_utils_url_utility__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_constants__ = __webpack_require__("./lib/utils/constants.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, object-shorthand, prefer-arrow-callback */
/* global Dropzone */




function toggleLoading($el, $icon, loading) {
  if (loading) {
    $el.disable();
    $icon.removeClass(__WEBPACK_IMPORTED_MODULE_1__lib_utils_constants__["b" /* HIDDEN_CLASS */]);
  } else {
    $el.enable();
    $icon.addClass(__WEBPACK_IMPORTED_MODULE_1__lib_utils_constants__["b" /* HIDDEN_CLASS */]);
  }
}

var BlobFileDropzone = function BlobFileDropzone(form, method) {
  _classCallCheck(this, BlobFileDropzone);

  var formDropzone = form.find('.dropzone');
  var submitButton = form.find('#submit-all');
  var submitButtonLoadingIcon = submitButton.find('.js-loading-icon');
  var dropzoneMessage = form.find('.dz-message');
  Dropzone.autoDiscover = false;

  var dropzone = formDropzone.dropzone({
    autoDiscover: false,
    autoProcessQueue: false,
    url: form.attr('action'),
    // Rails uses a hidden input field for PUT
    // http://stackoverflow.com/questions/21056482/how-to-set-method-put-in-form-tag-in-rails
    method: method,
    clickable: true,
    uploadMultiple: false,
    paramName: 'file',
    maxFilesize: gon.max_file_size || 10,
    parallelUploads: 1,
    maxFiles: 1,
    addRemoveLinks: true,
    previewsContainer: '.dropzone-previews',
    headers: {
      'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
    },
    init: function init() {
      this.on('addedfile', function () {
        toggleLoading(submitButton, submitButtonLoadingIcon, false);
        dropzoneMessage.addClass(__WEBPACK_IMPORTED_MODULE_1__lib_utils_constants__["b" /* HIDDEN_CLASS */]);
        $('.dropzone-alerts').html('').hide();
      });
      this.on('removedfile', function () {
        toggleLoading(submitButton, submitButtonLoadingIcon, false);
        dropzoneMessage.removeClass(__WEBPACK_IMPORTED_MODULE_1__lib_utils_constants__["b" /* HIDDEN_CLASS */]);
      });
      this.on('success', function (header, response) {
        $('#modal-upload-blob').modal('hide');
        window.gl.utils.visitUrl(response.filePath);
      });
      this.on('maxfilesexceeded', function (file) {
        dropzoneMessage.addClass(__WEBPACK_IMPORTED_MODULE_1__lib_utils_constants__["b" /* HIDDEN_CLASS */]);
        this.removeFile(file);
      });
      this.on('sending', function (file, xhr, formData) {
        formData.append('branch_name', form.find('.js-branch-name').val());
        formData.append('create_merge_request', form.find('.js-create-merge-request').val());
        formData.append('commit_message', form.find('.js-commit-message').val());
      });
    },
    // Override behavior of adding error underneath preview
    error: function error(file, errorMessage) {
      var stripped = $('<div/>').html(errorMessage).text();
      $('.dropzone-alerts').html('Error uploading file: "' + stripped + '"').show();
      this.removeFile(file);
    }
  });

  submitButton.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (dropzone[0].dropzone.getQueuedFiles().length === 0) {
      // eslint-disable-next-line no-alert
      alert('Please select a file');
      return false;
    }
    toggleLoading(submitButton, submitButtonLoadingIcon, true);
    dropzone[0].dropzone.processQueue();
    return false;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (BlobFileDropzone);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./blob/file_template_mediator.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__template_selectors_type_selector__ = __webpack_require__("./blob/template_selectors/type_selector.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__template_selectors_ci_yaml_selector__ = __webpack_require__("./blob/template_selectors/ci_yaml_selector.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__template_selectors_dockerfile_selector__ = __webpack_require__("./blob/template_selectors/dockerfile_selector.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__template_selectors_gitignore_selector__ = __webpack_require__("./blob/template_selectors/gitignore_selector.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__template_selectors_license_selector__ = __webpack_require__("./blob/template_selectors/license_selector.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */
/* global Flash */







var FileTemplateMediator = function () {
  function FileTemplateMediator(_ref) {
    var editor = _ref.editor,
        currentAction = _ref.currentAction;

    _classCallCheck(this, FileTemplateMediator);

    this.editor = editor;
    this.currentAction = currentAction;

    this.initTemplateSelectors();
    this.initTemplateTypeSelector();
    this.initDomElements();
    this.initDropdowns();
    this.initPageEvents();
  }

  _createClass(FileTemplateMediator, [{
    key: 'initTemplateSelectors',
    value: function initTemplateSelectors() {
      var _this = this;

      // Order dictates template type dropdown item order
      this.templateSelectors = [__WEBPACK_IMPORTED_MODULE_3__template_selectors_gitignore_selector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__template_selectors_ci_yaml_selector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__template_selectors_dockerfile_selector__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__template_selectors_license_selector__["a" /* default */]].map(function (TemplateSelectorClass) {
        return new TemplateSelectorClass({ mediator: _this });
      });
    }
  }, {
    key: 'initTemplateTypeSelector',
    value: function initTemplateTypeSelector() {
      this.typeSelector = new __WEBPACK_IMPORTED_MODULE_0__template_selectors_type_selector__["a" /* default */]({
        mediator: this,
        dropdownData: this.templateSelectors.map(function (templateSelector) {
          var cfg = templateSelector.config;

          return {
            name: cfg.name,
            key: cfg.key
          };
        })
      });
    }
  }, {
    key: 'initDomElements',
    value: function initDomElements() {
      var $templatesMenu = $('.template-selectors-menu');
      var $undoMenu = $templatesMenu.find('.template-selectors-undo-menu');
      var $fileEditor = $('.file-editor');

      this.$templatesMenu = $templatesMenu;
      this.$undoMenu = $undoMenu;
      this.$undoBtn = $undoMenu.find('button');
      this.$templateSelectors = $templatesMenu.find('.template-selector-dropdowns-wrap');
      this.$filenameInput = $fileEditor.find('.js-file-path-name-input');
      this.$fileContent = $fileEditor.find('#file-content');
      this.$commitForm = $fileEditor.find('form');
      this.$navLinks = $fileEditor.find('.nav-links');
    }
  }, {
    key: 'initDropdowns',
    value: function initDropdowns() {
      if (this.currentAction === 'create') {
        this.typeSelector.show();
      } else {
        this.hideTemplateSelectorMenu();
      }

      this.displayMatchedTemplateSelector();
    }
  }, {
    key: 'initPageEvents',
    value: function initPageEvents() {
      this.listenForFilenameInput();
      this.prepFileContentForSubmit();
      this.listenForPreviewMode();
    }
  }, {
    key: 'listenForFilenameInput',
    value: function listenForFilenameInput() {
      var _this2 = this;

      this.$filenameInput.on('keyup blur', function () {
        _this2.displayMatchedTemplateSelector();
      });
    }
  }, {
    key: 'prepFileContentForSubmit',
    value: function prepFileContentForSubmit() {
      var _this3 = this;

      this.$commitForm.submit(function () {
        _this3.$fileContent.val(_this3.editor.getValue());
      });
    }
  }, {
    key: 'listenForPreviewMode',
    value: function listenForPreviewMode() {
      var _this4 = this;

      this.$navLinks.on('click', 'a', function (e) {
        var urlPieces = e.target.href.split('#');
        var hash = urlPieces[1];
        if (hash === 'preview') {
          _this4.hideTemplateSelectorMenu();
        } else if (hash === 'editor') {
          _this4.showTemplateSelectorMenu();
        }
      });
    }
  }, {
    key: 'selectTemplateType',
    value: function selectTemplateType(item, e) {
      if (e) {
        e.preventDefault();
      }

      this.templateSelectors.forEach(function (selector) {
        if (selector.config.key === item.key) {
          selector.show();
        } else {
          selector.hide();
        }
      });

      this.typeSelector.setToggleText(item.name);

      this.cacheToggleText();
    }
  }, {
    key: 'selectTemplateTypeOptions',
    value: function selectTemplateTypeOptions(options) {
      this.selectTemplateType(options.selectedObj, options.e);
    }
  }, {
    key: 'selectTemplateFile',
    value: function selectTemplateFile(selector, query, data) {
      var _this5 = this;

      selector.renderLoading();
      // in case undo menu is already already there
      this.destroyUndoMenu();
      this.fetchFileTemplate(selector.config.endpoint, query, data).then(function (file) {
        _this5.showUndoMenu();
        _this5.setEditorContent(file);
        _this5.setFilename(selector.config.name);
        selector.renderLoaded();
      }).catch(function (err) {
        return new Flash('An error occurred while fetching the template: ' + err);
      });
    }
  }, {
    key: 'displayMatchedTemplateSelector',
    value: function displayMatchedTemplateSelector() {
      var _this6 = this;

      var currentInput = this.getFilename();
      this.templateSelectors.forEach(function (selector) {
        var match = selector.config.pattern.test(currentInput);

        if (match) {
          _this6.typeSelector.show();
          _this6.selectTemplateType(selector.config);
          _this6.showTemplateSelectorMenu();
        }
      });
    }
  }, {
    key: 'fetchFileTemplate',
    value: function fetchFileTemplate(apiCall, query, data) {
      return new Promise(function (resolve) {
        var resolveFile = function resolveFile(file) {
          return resolve(file);
        };

        if (!data) {
          apiCall(query, resolveFile);
        } else {
          apiCall(query, data, resolveFile);
        }
      });
    }
  }, {
    key: 'setEditorContent',
    value: function setEditorContent(file) {
      if (!file && file !== '') return;

      var newValue = file.content || file;

      this.editor.setValue(newValue, 1);

      this.editor.focus();

      this.editor.navigateFileStart();
    }
  }, {
    key: 'findTemplateSelectorByKey',
    value: function findTemplateSelectorByKey(key) {
      return this.templateSelectors.find(function (selector) {
        return selector.config.key === key;
      });
    }
  }, {
    key: 'showUndoMenu',
    value: function showUndoMenu() {
      var _this7 = this;

      this.$undoMenu.removeClass('hidden');

      this.$undoBtn.on('click', function () {
        _this7.restoreFromCache();
        _this7.destroyUndoMenu();
      });
    }
  }, {
    key: 'destroyUndoMenu',
    value: function destroyUndoMenu() {
      this.cacheFileContents();
      this.cacheToggleText();
      this.$undoMenu.addClass('hidden');
      this.$undoBtn.off('click');
    }
  }, {
    key: 'hideTemplateSelectorMenu',
    value: function hideTemplateSelectorMenu() {
      this.$templatesMenu.hide();
    }
  }, {
    key: 'showTemplateSelectorMenu',
    value: function showTemplateSelectorMenu() {
      this.$templatesMenu.show();
    }
  }, {
    key: 'cacheToggleText',
    value: function cacheToggleText() {
      this.cachedToggleText = this.getTemplateSelectorToggleText();
    }
  }, {
    key: 'cacheFileContents',
    value: function cacheFileContents() {
      this.cachedContent = this.editor.getValue();
      this.cachedFilename = this.getFilename();
    }
  }, {
    key: 'restoreFromCache',
    value: function restoreFromCache() {
      this.setEditorContent(this.cachedContent);
      this.setFilename(this.cachedFilename);
      this.setTemplateSelectorToggleText();
    }
  }, {
    key: 'getTemplateSelectorToggleText',
    value: function getTemplateSelectorToggleText() {
      return this.$templateSelectors.find('.js-template-selector-wrap:visible .dropdown-toggle-text').text();
    }
  }, {
    key: 'setTemplateSelectorToggleText',
    value: function setTemplateSelectorToggleText() {
      return this.$templateSelectors.find('.js-template-selector-wrap:visible .dropdown-toggle-text').text(this.cachedToggleText);
    }
  }, {
    key: 'getTypeSelectorToggleText',
    value: function getTypeSelectorToggleText() {
      return this.typeSelector.getToggleText();
    }
  }, {
    key: 'getFilename',
    value: function getFilename() {
      return this.$filenameInput.val();
    }
  }, {
    key: 'setFilename',
    value: function setFilename(name) {
      this.$filenameInput.val(name);
    }
  }, {
    key: 'getSelected',
    value: function getSelected() {
      return this.templateSelectors.find(function (selector) {
        return selector.selected;
      });
    }
  }]);

  return FileTemplateMediator;
}();

/* harmony default export */ __webpack_exports__["a"] = (FileTemplateMediator);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./blob/file_template_selector.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FileTemplateSelector = function () {
  function FileTemplateSelector(mediator) {
    _classCallCheck(this, FileTemplateSelector);

    this.mediator = mediator;
    this.$dropdown = null;
    this.$wrapper = null;
  }

  _createClass(FileTemplateSelector, [{
    key: 'init',
    value: function init() {
      var cfg = this.config;

      this.$dropdown = $(cfg.dropdown);
      this.$wrapper = $(cfg.wrapper);
      this.$loadingIcon = this.$wrapper.find('.fa-chevron-down');
      this.$dropdownToggleText = this.$wrapper.find('.dropdown-toggle-text');

      this.initDropdown();
    }
  }, {
    key: 'show',
    value: function show() {
      if (this.$dropdown === null) {
        this.init();
      }

      this.$wrapper.removeClass('hidden');
    }
  }, {
    key: 'hide',
    value: function hide() {
      if (this.$dropdown !== null) {
        this.$wrapper.addClass('hidden');
      }
    }
  }, {
    key: 'getToggleText',
    value: function getToggleText() {
      return this.$dropdownToggleText.text();
    }
  }, {
    key: 'setToggleText',
    value: function setToggleText(text) {
      this.$dropdownToggleText.text(text);
    }
  }, {
    key: 'renderLoading',
    value: function renderLoading() {
      this.$loadingIcon.addClass('fa-spinner fa-spin').removeClass('fa-chevron-down');
    }
  }, {
    key: 'renderLoaded',
    value: function renderLoaded() {
      this.$loadingIcon.addClass('fa-chevron-down').removeClass('fa-spinner fa-spin');
    }
  }, {
    key: 'reportSelection',
    value: function reportSelection(options) {
      var query = options.query,
          e = options.e,
          data = options.data;

      e.preventDefault();
      return this.mediator.selectTemplateFile(this, query, data);
    }
  }, {
    key: 'reportSelectionName',
    value: function reportSelectionName(options) {
      var opts = options;
      opts.query = options.selectedObj.name;

      this.reportSelection(opts);
    }
  }]);

  return FileTemplateSelector;
}();

/* harmony default export */ __webpack_exports__["a"] = (FileTemplateSelector);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./blob/template_selectors/ci_yaml_selector.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("./api.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__file_template_selector__ = __webpack_require__("./blob/file_template_selector.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var BlobCiYamlSelector = function (_FileTemplateSelector) {
  _inherits(BlobCiYamlSelector, _FileTemplateSelector);

  function BlobCiYamlSelector(_ref) {
    var mediator = _ref.mediator;

    _classCallCheck(this, BlobCiYamlSelector);

    var _this = _possibleConstructorReturn(this, (BlobCiYamlSelector.__proto__ || Object.getPrototypeOf(BlobCiYamlSelector)).call(this, mediator));

    _this.config = {
      key: 'gitlab-ci-yaml',
      name: '.gitlab-ci.yml',
      pattern: /(.gitlab-ci.yml)/,
      endpoint: __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].gitlabCiYml,
      dropdown: '.js-gitlab-ci-yml-selector',
      wrapper: '.js-gitlab-ci-yml-selector-wrap'
    };
    return _this;
  }

  _createClass(BlobCiYamlSelector, [{
    key: 'initDropdown',
    value: function initDropdown() {
      var _this2 = this;

      // maybe move to super class as well
      this.$dropdown.glDropdown({
        data: this.$dropdown.data('data'),
        filterable: true,
        selectable: true,
        toggleLabel: function toggleLabel(item) {
          return item.name;
        },
        search: {
          fields: ['name']
        },
        clicked: function clicked(options) {
          return _this2.reportSelectionName(options);
        },
        text: function text(item) {
          return item.name;
        }
      });
    }
  }]);

  return BlobCiYamlSelector;
}(__WEBPACK_IMPORTED_MODULE_1__file_template_selector__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (BlobCiYamlSelector);

/***/ }),

/***/ "./blob/template_selectors/dockerfile_selector.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("./api.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__file_template_selector__ = __webpack_require__("./blob/file_template_selector.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var DockerfileSelector = function (_FileTemplateSelector) {
  _inherits(DockerfileSelector, _FileTemplateSelector);

  function DockerfileSelector(_ref) {
    var mediator = _ref.mediator;

    _classCallCheck(this, DockerfileSelector);

    var _this = _possibleConstructorReturn(this, (DockerfileSelector.__proto__ || Object.getPrototypeOf(DockerfileSelector)).call(this, mediator));

    _this.config = {
      key: 'dockerfile',
      name: 'Dockerfile',
      pattern: /(Dockerfile)/,
      endpoint: __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].dockerfileYml,
      dropdown: '.js-dockerfile-selector',
      wrapper: '.js-dockerfile-selector-wrap'
    };
    return _this;
  }

  _createClass(DockerfileSelector, [{
    key: 'initDropdown',
    value: function initDropdown() {
      var _this2 = this;

      // maybe move to super class as well
      this.$dropdown.glDropdown({
        data: this.$dropdown.data('data'),
        filterable: true,
        selectable: true,
        toggleLabel: function toggleLabel(item) {
          return item.name;
        },
        search: {
          fields: ['name']
        },
        clicked: function clicked(options) {
          return _this2.reportSelectionName(options);
        },
        text: function text(item) {
          return item.name;
        }
      });
    }
  }]);

  return DockerfileSelector;
}(__WEBPACK_IMPORTED_MODULE_1__file_template_selector__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (DockerfileSelector);

/***/ }),

/***/ "./blob/template_selectors/gitignore_selector.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("./api.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__file_template_selector__ = __webpack_require__("./blob/file_template_selector.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var BlobGitignoreSelector = function (_FileTemplateSelector) {
  _inherits(BlobGitignoreSelector, _FileTemplateSelector);

  function BlobGitignoreSelector(_ref) {
    var mediator = _ref.mediator;

    _classCallCheck(this, BlobGitignoreSelector);

    var _this = _possibleConstructorReturn(this, (BlobGitignoreSelector.__proto__ || Object.getPrototypeOf(BlobGitignoreSelector)).call(this, mediator));

    _this.config = {
      key: 'gitignore',
      name: '.gitignore',
      pattern: /(.gitignore)/,
      endpoint: __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].gitignoreText,
      dropdown: '.js-gitignore-selector',
      wrapper: '.js-gitignore-selector-wrap'
    };
    return _this;
  }

  _createClass(BlobGitignoreSelector, [{
    key: 'initDropdown',
    value: function initDropdown() {
      var _this2 = this;

      this.$dropdown.glDropdown({
        data: this.$dropdown.data('data'),
        filterable: true,
        selectable: true,
        toggleLabel: function toggleLabel(item) {
          return item.name;
        },
        search: {
          fields: ['name']
        },
        clicked: function clicked(options) {
          return _this2.reportSelectionName(options);
        },
        text: function text(item) {
          return item.name;
        }
      });
    }
  }]);

  return BlobGitignoreSelector;
}(__WEBPACK_IMPORTED_MODULE_1__file_template_selector__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (BlobGitignoreSelector);

/***/ }),

/***/ "./blob/template_selectors/license_selector.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("./api.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__file_template_selector__ = __webpack_require__("./blob/file_template_selector.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var BlobLicenseSelector = function (_FileTemplateSelector) {
  _inherits(BlobLicenseSelector, _FileTemplateSelector);

  function BlobLicenseSelector(_ref) {
    var mediator = _ref.mediator;

    _classCallCheck(this, BlobLicenseSelector);

    var _this = _possibleConstructorReturn(this, (BlobLicenseSelector.__proto__ || Object.getPrototypeOf(BlobLicenseSelector)).call(this, mediator));

    _this.config = {
      key: 'license',
      name: 'LICENSE',
      pattern: /^(.+\/)?(licen[sc]e|copying)($|\.)/i,
      endpoint: __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].licenseText,
      dropdown: '.js-license-selector',
      wrapper: '.js-license-selector-wrap'
    };
    return _this;
  }

  _createClass(BlobLicenseSelector, [{
    key: 'initDropdown',
    value: function initDropdown() {
      var _this2 = this;

      this.$dropdown.glDropdown({
        data: this.$dropdown.data('data'),
        filterable: true,
        selectable: true,
        toggleLabel: function toggleLabel(item) {
          return item.name;
        },
        search: {
          fields: ['name']
        },
        clicked: function clicked(options) {
          var e = options.e;

          var el = options.$el;
          var query = options.selectedObj;

          var data = {
            project: _this2.$dropdown.data('project'),
            fullname: _this2.$dropdown.data('fullname')
          };

          _this2.reportSelection({
            query: query.id,
            el: el,
            e: e,
            data: data
          });
        },
        text: function text(item) {
          return item.name;
        }
      });
    }
  }]);

  return BlobLicenseSelector;
}(__WEBPACK_IMPORTED_MODULE_1__file_template_selector__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (BlobLicenseSelector);

/***/ }),

/***/ "./blob/template_selectors/type_selector.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__file_template_selector__ = __webpack_require__("./blob/file_template_selector.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var FileTemplateTypeSelector = function (_FileTemplateSelector) {
  _inherits(FileTemplateTypeSelector, _FileTemplateSelector);

  function FileTemplateTypeSelector(_ref) {
    var mediator = _ref.mediator,
        dropdownData = _ref.dropdownData;

    _classCallCheck(this, FileTemplateTypeSelector);

    var _this = _possibleConstructorReturn(this, (FileTemplateTypeSelector.__proto__ || Object.getPrototypeOf(FileTemplateTypeSelector)).call(this, mediator));

    _this.mediator = mediator;
    _this.config = {
      dropdown: '.js-template-type-selector',
      wrapper: '.js-template-type-selector-wrap',
      dropdownData: dropdownData
    };
    return _this;
  }

  _createClass(FileTemplateTypeSelector, [{
    key: 'initDropdown',
    value: function initDropdown() {
      var _this2 = this;

      this.$dropdown.glDropdown({
        data: this.config.dropdownData,
        filterable: false,
        selectable: true,
        toggleLabel: function toggleLabel(item) {
          return item.name;
        },
        clicked: function clicked(options) {
          return _this2.mediator.selectTemplateTypeOptions(options);
        },
        text: function text(item) {
          return item.name;
        }
      });
    }
  }]);

  return FileTemplateTypeSelector;
}(__WEBPACK_IMPORTED_MODULE_0__file_template_selector__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (FileTemplateTypeSelector);

/***/ }),

/***/ "./blob_edit/blob_bundle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__edit_blob__ = __webpack_require__("./blob_edit/edit_blob.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__blob_blob_file_dropzone__ = __webpack_require__("./blob/blob_file_dropzone.js");
/* eslint-disable func-names, space-before-function-paren, prefer-arrow-callback, no-var, quotes, vars-on-top, no-unused-vars, no-new, max-len */
/* global EditBlob */
/* global NewCommitForm */




$(function () {
  var editBlobForm = $('.js-edit-blob-form');
  var uploadBlobForm = $('.js-upload-blob-form');
  var deleteBlobForm = $('.js-delete-blob-form');

  if (editBlobForm.length) {
    var urlRoot = editBlobForm.data('relative-url-root');
    var assetsPath = editBlobForm.data('assets-prefix');
    var blobLanguage = editBlobForm.data('blob-language');
    var currentAction = $('.js-file-title').data('current-action');

    new __WEBPACK_IMPORTED_MODULE_0__edit_blob__["a" /* default */]('' + urlRoot + assetsPath, blobLanguage, currentAction);
    new NewCommitForm(editBlobForm);
  }

  if (uploadBlobForm.length) {
    var method = uploadBlobForm.data('method');

    new __WEBPACK_IMPORTED_MODULE_1__blob_blob_file_dropzone__["a" /* default */](uploadBlobForm, method);
    new NewCommitForm(uploadBlobForm);

    window.gl.utils.disableButtonIfEmptyField(uploadBlobForm.find('.js-commit-message'), '.btn-upload-file');
  }

  if (deleteBlobForm.length) {
    new NewCommitForm(deleteBlobForm);
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./blob_edit/edit_blob.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__blob_file_template_mediator__ = __webpack_require__("./blob/file_template_mediator.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global ace */



var EditBlob = function () {
  function EditBlob(assetsPath, aceMode, currentAction) {
    _classCallCheck(this, EditBlob);

    this.configureAceEditor(aceMode, assetsPath);
    this.initModePanesAndLinks();
    this.initSoftWrap();
    this.initFileSelectors(currentAction);
  }

  _createClass(EditBlob, [{
    key: 'configureAceEditor',
    value: function configureAceEditor(aceMode, assetsPath) {
      ace.config.set('modePath', assetsPath + '/ace');
      ace.config.loadModule('ace/ext/searchbox');

      this.editor = ace.edit('editor');

      // This prevents warnings re: automatic scrolling being logged
      this.editor.$blockScrolling = Infinity;

      this.editor.focus();

      if (aceMode) {
        this.editor.getSession().setMode('ace/mode/' + aceMode);
      }
    }
  }, {
    key: 'initFileSelectors',
    value: function initFileSelectors(currentAction) {
      this.fileTemplateMediator = new __WEBPACK_IMPORTED_MODULE_0__blob_file_template_mediator__["a" /* default */]({
        currentAction: currentAction,
        editor: this.editor
      });
    }
  }, {
    key: 'initModePanesAndLinks',
    value: function initModePanesAndLinks() {
      var _this = this;

      this.$editModePanes = $('.js-edit-mode-pane');
      this.$editModeLinks = $('.js-edit-mode a');
      this.$editModeLinks.on('click', function (e) {
        return _this.editModeLinkClickHandler(e);
      });
    }
  }, {
    key: 'editModeLinkClickHandler',
    value: function editModeLinkClickHandler(e) {
      e.preventDefault();

      var currentLink = $(e.target);
      var paneId = currentLink.attr('href');
      var currentPane = this.$editModePanes.filter(paneId);

      this.$editModeLinks.parent().removeClass('active hover');

      currentLink.parent().addClass('active hover');

      this.$editModePanes.hide();

      currentPane.fadeIn(200);

      if (paneId === '#preview') {
        this.$toggleButton.hide();
        return $.post(currentLink.data('preview-url'), {
          content: this.editor.getValue()
        }, function (response) {
          currentPane.empty().append(response);
          return currentPane.renderGFM();
        });
      }

      this.$toggleButton.show();

      return this.editor.focus();
    }
  }, {
    key: 'initSoftWrap',
    value: function initSoftWrap() {
      var _this2 = this;

      this.isSoftWrapped = false;
      this.$toggleButton = $('.soft-wrap-toggle');
      this.$toggleButton.on('click', function () {
        return _this2.toggleSoftWrap();
      });
    }
  }, {
    key: 'toggleSoftWrap',
    value: function toggleSoftWrap() {
      this.isSoftWrapped = !this.isSoftWrapped;
      this.$toggleButton.toggleClass('soft-wrap-active', this.isSoftWrapped);
      this.editor.getSession().setUseWrapMode(this.isSoftWrapped);
    }
  }]);

  return EditBlob;
}();

/* harmony default export */ __webpack_exports__["a"] = (EditBlob);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ })

},["./blob_edit/blob_bundle.js"]);


// WEBPACK FOOTER //
// blob.6043bed197eb079db95f.bundle.js